export const LOCALES: Locale[] = ['en', 'es', 'de', 'fr', 'nl', 'pt', 'it', 'sv', 'da', 'nb', 'fi'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_NAMES: Record<string, string> = {
  da: 'Dansk',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fi: 'Suomi',
  fr: 'Français',
  it: 'Italiano',
  nb: 'Norsk',
  nl: 'Nederlands',
  pt: 'Português',
  sv: 'Svenska',
};

export type Locale = 'en' | 'es' | 'de' | 'fr' | 'nl' | 'pt' | 'it' | 'sv' | 'da' | 'nb' | 'fi';
